export function getIndicatorKey(indicator, params, symbol, timeframe, paneType) {
  // Must match whatever structure your backend uses to rehydrate indicators on timeframe change!
  return [
    indicator,
    ...Object.entries(params).sort().map(([k, v]) => `${k}:${v}`),
    symbol,
    timeframe,
    paneType
  ].join('_');
}

export const padIndicatorData = (candles, indicatorData) => {
    const map = new Map(indicatorData.map(d => [d.time, d.value]));
    let matched = 0, unmatched = 0;
    const result = candles.map(c => {
        // Always look up by the original (real) timestamp because indicator
        // data from the backend uses real timestamps.  Using the compressed
        // `c.time` would collide with pre-gap real timestamps after
        // compressGaps shifts post-gap bars backward.
        const lookupTime = c.time_real ?? c.time;
        const v = map.get(lookupTime);
        if (Number.isFinite(v)) { matched++; } else { unmatched++; }
        return Number.isFinite(v)
            ? { time: c.time, value: v }
            : { time: c.time };
    });
    return result;
};
